import { CoeDataAnalysis } from "src/models/coeDataAnalysis";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeDataAnalysisEntityModel = createEntityModel<CoeDataAnalysis>();
